import createReactComponent from '../createReactComponent';
export default createReactComponent('crown', 'IconCrown', [
  ['path', { d: 'M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z', key: 'svg-0' }],
]);
